// this is an automatically generated file from the ßoilerplate framework

// /srv/codepad-project/@vue-modules/app/vue;
import app from '@/app.router.js';


export default {app: app, };